var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 551.45 424.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#68737a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516,62.5v98a15.16,15.16,0,0,0-4.49-.68H438.71a52.88,52.88,0,0,0,0,105.76h72.76a15.16,15.16,0,0,0,4.49-.68V361.7a62.5,62.5,0,0,1-62.5,62.5H62.5A62.5,62.5,0,0,1,0,361.7V62.5A62.51,62.51,0,0,1,62.5,0h391A62.5,62.5,0,0,1,516,62.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516,135.08a39.1,39.1,0,0,0-4.49-.25H438.71a77.88,77.88,0,1,0,0,155.76h72.76a39.1,39.1,0,0,0,4.49-.25,40,40,0,0,0,35.49-39.74V174.81A40,40,0,0,0,516,135.08ZM526.45,250.6a14.95,14.95,0,0,1-15,15H438.71a52.88,52.88,0,0,1,0-105.76h72.76a14.95,14.95,0,0,1,15,15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 438.16,
    cy: 212.23,
    r: 24.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.42510d8ca2a51a31ccf92171e35219a3.svg";
export { ForwardRef as ReactComponent };